import * as authentications from './authentications';
import * as clubhouses from './clubhouses';
import * as countries from './countries';
import * as courses from './courses';
import * as events from './events';
import * as licenses from './licenses';
import * as rounds from './rounds';
import * as shots from './shots';
import * as users from './users';
import * as shop from './shop';
import * as transactions from './transactions';
import * as seasons from './seasons';
import * as admin from './admin';
import * as partners from './partners';
import * as challenges from './challenges';
import * as trusimpartners from './trusimpartners';

export default {
  authentications,
  clubhouses,
  countries,
  courses,
  events,
  licenses,
  rounds,
  shots,
  users,
  shop,
  transactions,
  seasons,
  admin,
  partners,
  challenges,
  trusimpartners,
};
